/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './Requests.css';
import { API_ENDPOINTS } from '../config/api';
import { isReadOnly } from '../config/academicYear';

const Requests = () => {
  const archiveReadOnly = isReadOnly();
  const { t } = useTranslation();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const [talepler, setTalepler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState('');
  const userId = sessionStorage.getItem('akademisyen_id');

  const [activeTab, setActiveTab] = useState(archiveReadOnly ? 'history' : 'create');

  useEffect(() => {
    if (activeTab === 'history') {
      loadPastRequests();
    }
  }, [activeTab, userId]);

  const loadPastRequests = () => {
    if (!userId) {
      setLoadError(t('requests.mustLogin'));
      setLoading(false);
      return;
    }

    setLoading(true);
    fetch(API_ENDPOINTS.TALEP)
      .then(res => res.json())
      .then(async data => {
        if (data.success) {
          const myTalepler = data.talepler.filter(t => String(t.user_id) === String(userId));
          const taleplerWithYanit = await Promise.all(myTalepler.map(async t => {
            const yanitRes = await fetch(`${API_ENDPOINTS.TALEP_YANIT}?talep_id=${t.id}`);
            const yanitData = await yanitRes.json();
            return { ...t, yanitlar: yanitData.success ? yanitData.yanitlar : [] };
          }));
          setTalepler(taleplerWithYanit);
        } else {
          setLoadError(data.error || t('requests.fetchError'));
        }
      })
      .catch(() => setLoadError(t('requests.serverError')))
      .finally(() => setLoading(false));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (archiveReadOnly) return;
    setError('');
    setSuccess(false);
    const akademisyenId = sessionStorage.getItem('akademisyen_id');
    try {
      const response = await fetch(API_ENDPOINTS.TALEP, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          title,
          description,
          user_id: akademisyenId ? parseInt(akademisyenId) : null
        })
      });
      const data = await response.json();
      if (data.success) {
        setSuccess(true);
        setTitle('');
        setDescription('');
      } else {
        setError(data.error || t('requests.error'));
      }
    } catch (err) {
      setError(t('requests.serverError'));
    }
  };

  return (
    <div className="talep-container">
      <div className="talep-tabs">
        {!archiveReadOnly && <button
          className={`talep-tab ${activeTab === 'create' ? 'active' : ''}`}
          onClick={() => setActiveTab('create')}
        >
          <span className="tab-icon">📩</span>
          {t('requests.newRequest')}
        </button>}
        <button
          className={`talep-tab ${activeTab === 'history' ? 'active' : ''}`}
          onClick={() => setActiveTab('history')}
        >
          <span className="tab-icon">🗂️</span>
          {t('requests.myRequests')}
        </button>
      </div>

      {!archiveReadOnly && activeTab === 'create' && (
        <div className="talep-content">
          <h2 className="talep-title">{t('requests.createTitle')}</h2>
          {success && <div className="talep-success">{t('requests.requestReceived')}</div>}
          {error && <div className="talep-error">{error}</div>}
          <form className="talep-form" onSubmit={handleSubmit}>
            <div>
              <label>{t('requests.titleLabel')}</label>
              <input
                type="text"
                value={title}
                onChange={e => setTitle(e.target.value)}
                required
                placeholder={t('requests.titlePlaceholder')}
              />
            </div>
            <div>
              <label>{t('requests.descriptionLabel')}</label>
              <textarea
                value={description}
                onChange={e => setDescription(e.target.value)}
                required
                rows={6}
                placeholder={t('requests.descriptionPlaceholder')}
              />
            </div>
            <button type="submit" className="talep-submit-btn">
              <span className="btn-icon">📤</span>
              {t('requests.sendRequest')}
            </button>
          </form>
        </div>
      )}

      {activeTab === 'history' && (
        <div className="talep-content">
          <h2 className="talep-title">{t('requests.pastRequests')}</h2>
          {loading && <div className="talep-loading">{t('requests.loading')}</div>}
          {loadError && <div className="talep-error">{loadError}</div>}
          {!loading && !loadError && (
            talepler.length === 0 ? (
              <div className="talep-empty">
                <span className="empty-icon">📭</span>
                <p>{t('requests.noRequests')}</p>
              </div>
            ) : (
              <div className="talep-list">
                {talepler.map(talep => (
                  <div key={talep.id} className="talep-item">
                    <div className="talep-item-header">
                      <h3 className="talep-item-title">{talep.title}</h3>
                      <span className="talep-item-date">
                        {talep.created_at ? new Date(talep.created_at).toLocaleDateString() : '-'}
                      </span>
                    </div>
                    <div className="talep-item-desc">{talep.description}</div>
                    <div className="talep-replies">
                      <div className="talep-replies-header">
                        <span className="replies-icon">💬</span>
                        <strong>{t('requests.replies')}</strong>
                        <span className="replies-count">({talep.yanitlar.length})</span>
                      </div>
                      {talep.yanitlar.length === 0 ? (
                        <div className="talep-reply-empty">{t('requests.noReply')}</div>
                      ) : (
                        <div className="talep-reply-list">
                          {talep.yanitlar.map(y => (
                            <div key={y.id} className="talep-reply-item">
                              <div className="reply-text">{y.yanit}</div>
                              <div className="reply-meta">
                                {y.created_at ? new Date(y.created_at).toLocaleString() : ''}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default Requests;
